import { SdsWebApi } from "../generated/apis/SdsWebApi";
import { Configuration, ConfigurationParameters } from "../generated/runtime";
import isDev from "../../utils/environmentUtils";

const serviceUrl = new URLSearchParams(window.location.search).get("service_url");
const configurationParameters: ConfigurationParameters = {
    basePath:
        serviceUrl ||
        (isDev()
            ? "http://localhost/VikingDS_DEV"
            : window.location.href.substring(0, window.location.href.indexOf("model_selector") - 1)),
};
export const configuration = new Configuration(configurationParameters);
const client = new SdsWebApi(configuration);

export default client;
